export default __webpack_public_path__ + "05c7395cb53860a7e2fa8fa3c058128e.jpg";